/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports

export const standartCouloms = [
  {
    type: 'normal',
    header: [
      {
        label: 'Prénom',
        key: 'firstname',
        width: '12vw',
        option: {
          type: 'link',
        },
      },
      {
        label: 'Nom',
        key: 'lastname',
        width: '12vw',
        option: {
          type: 'link',
        },
      },
      {
        label: 'Email',
        key: 'email',
        width: '15vw',
      },
      {
        label: 'Code postal',
        key: 'postal_code',
        width: '12vw',
      },
      {
        label: 'Admin. de rattachement',
        width: '15vw',
        key: [
          'upper_hierarchy.data.attributes.lastname',
          'upper_hierarchy.data.attributes.firstname',
        ],
      },
      {
        label: 'Utilisateurs rattachés',
        key: 'subordinates',
        width: '15vw',
        option: {
          type: 'button',
          labelText: 'consulter',
        },
      },
    ],
  },
  {
    type: 'action',
    header: [
      {
        label: 'Actions',
        width: '16vw',
        key: 'name3',
        option: {
          type: 'Action',
          listAction: ['disable', 'edit', 'delete'],
        },
      },
    ],
  },
];

export const standartDirection = [
  {
    type: 'normal',
    header: [
      {
        label: 'Prénom',
        key: 'firstname',
        width: '15vw',
        option: {
          type: 'link',
        },
      },
      {
        label: 'Nom',
        key: 'lastname',
        width: '15vw',
        option: {
          type: 'link',
        },
      },
      {
        label: 'Email',
        width: '20vw',
        key: 'email',
      },
      {
        label: 'Code postal',
        key: 'postal_code',
        width: '15vw',
      },
      {
        label: 'Utilisateurs rattachés',
        key: 'subordinates',
        width: '15vw',
        option: {
          type: 'button',
          labelText: 'consulter',
        },
      },
    ],
  },
  {
    type: 'action',
    header: [
      {
        label: 'Actions',
        width: '15vw',
        key: 'name3',
        option: {
          type: 'Action',
          listAction: ['disable', 'edit', 'delete'],
        },
      },
    ],
  },
];

export const standartBeneficaire = [
  {
    type: 'normal',
    header: [
      {
        label: 'Utilisateurs',
        key: 'userIdentity',
        width: '20vw',
        option: {
          type: 'userIdentity',
        },
      },
      {
        label: 'Prestations',
        key: 'userPrestations',
        width: '31vw',
        option: {
          type: 'serviceBadges',
          source: 'userServices',
          maxVisible: 3,
        },
      },
      {
        label: 'Statut',
        key: 'isActivated',
        width: '9vw',
        option: {
          type: 'statusBadge',
        },
      },
      {
        label: 'Assistant IA',
        key: 'assistantIA',
        width: '12vw',
        option: {
          type: 'button',
          labelText: 'Consulter',
        },
      },
      {
        label: 'Résultats des tests',
        key: 'viewTest',
        width: '14vw',
        option: {
          type: 'button',
          labelText: 'Consulter',
        },
      },
    ],
  },
  {
    type: 'action',
    header: [
      {
        label: 'Actions',
        key: 'name3',
        option: {
          type: 'Action',
          listAction: ['edit'],
        },
        width: '8vw',
      },
    ],
  },
];

export const standartConsultant = [
  {
    type: 'normal',
    header: [
      {
        label: 'Utilisateurs',
        key: 'userIdentity',
        width: '36vw',
        option: {
          type: 'userIdentity',
        },
      },
      {
        label: 'Statut',
        key: 'isActivated',
        width: '14vw',
        option: {
          type: 'statusBadge',
        },
      },
      {
        label: 'Utilisateurs rattachés',
        key: 'subordinates',
        width: '28vw',
        option: {
          type: 'button',
          labelText: 'Consulter',
        },
      },
    ],
  },
  {
    type: 'action',
    header: [
      {
        label: 'Actions',
        width: '16vw',
        key: 'name3',
        option: {
          type: 'Action',
          listAction: ['edit'],
        },
      },
    ],
  },
];

/** Shared table layout for Direction / managers / consultants (all non-beneficiary admin tabs). */
export const standartHierarchy = standartConsultant;
